module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10259.7cf78e03.jpg";